<template>
  <div>
    <v-tabs fixed-tabs>
      <v-tab to="/analytics">Overview</v-tab>
      <v-tab to="/analytics/invoices">Invoices</v-tab>
    </v-tabs>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'analytics-page',

    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/AnalyticsPage.vue